import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'EMV' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'EMV', label: 'Ease of Movement', pane: 'sub', params: [14, 9], outputs: ['emv', 'maEmv'] })
